export default "__VITE_ASSET__cc046101__"